import { Link } from 'react-router-dom';

const ServicesHero = () => {
  return (
    <section className="relative bg-navy py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1ab628177908407da15622d3be1020d0.jpg"
          alt="Commercial Electrical Services"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/90 via-navy/80 to-navy/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <nav className="flex items-center gap-2 text-gold text-sm mb-6">
            <Link to="/" className="hover:text-gold-light cursor-pointer">Home</Link>
            <span>/</span>
            <span>Commercial Services</span>
          </nav>

          <h1 className="text-4xl lg:text-5xl font-extrabold text-white mb-6 leading-tight">
            COMMERCIAL ELECTRICAL SERVICES
          </h1>

          <div className="h-1 w-32 bg-gold mb-8"></div>

          <p className="text-gray-300 text-lg leading-relaxed mb-6">
            NS Electrical WA specialises in commercial electrical installations and maintenance. We work with builders, property managers and business owners to deliver compliant and reliable electrical solutions.
          </p>

          <p className="text-gray-300 text-lg leading-relaxed mb-10">
            We focus on safety, compliance and professional project delivery.
          </p>

          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-gold text-navy px-8 py-4 rounded-lg font-bold text-sm tracking-wider hover:bg-gold/90 transition-all whitespace-nowrap cursor-pointer"
          >
            REQUEST A QUOTE
            <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;